import React, { useState } from 'react';
import { User, Lock, ArrowRight, Eye, EyeOff } from 'lucide-react';
import { db } from '../firebase'; // Firebase config import
import { ref, get } from "firebase/database"; // Data read karne ke liye
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Register.css'; 
import './Login.css'; 

const Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    
    // Form States
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();

        // Basic Validation
        if (!username || !password) {
            Swal.fire({
                icon: 'warning',
                title: 'Empty Fields',
                text: 'Please enter both username and password.',
            });
            return;
        }

        try {
            // Show Loading
            Swal.fire({
                title: 'Verifying...',
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false
            });

            // 1. Database se user ka data mangwana
            const userRef = ref(db, 'users/' + username);
            const snapshot = await get(userRef);

            if (snapshot.exists()) {
                const userData = snapshot.val();

                // 2. Password Match karna
                if (userData.password === password) {
                    
                    // Login Success! 
                    // Browser ki memory (localStorage) mein user save karein
                    localStorage.setItem('user', JSON.stringify(userData));

                    Swal.fire({
                        icon: 'success',
                        title: 'Login Successful!',
                        text: `Welcome back, ${username}!`,
                        timer: 1500,
                        showConfirmButton: false
                    });

                    // ✅ FIX: window.location.href use kiya hai taake App fresh load ho
                    // Aur navigate('/') direct Home layout pe le jaye
                    setTimeout(() => {
                        window.location.href = "/"; 
                    }, 1500);

                } else {
                    // Password galat hai
                    Swal.fire({
                        icon: 'error',
                        title: 'Login Failed',
                        text: 'Incorrect password. Please try again.',
                    });
                }
            } else {
                // Username hi nahi mila
                Swal.fire({
                    icon: 'error',
                    title: 'User Not Found',
                    text: 'This username is not registered.',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Connection failed: ' + error.message,
            });
        }
    };

    return (
        <div className="reg-container">
            <div className="reg-card">
                <div className="reg-header">
                    <h1>Welcome Back</h1>
                    <p>Login to manage your trading assets and portfolio.</p>
                </div>

                <form className="reg-form" onSubmit={handleLogin}>
                    <div className="input-group">
                        <label>Username</label>
                        <div className="input-wrapper">
                            <User size={18} className="input-icon" />
                            <input 
                                type="text" 
                                placeholder="Enter your username" 
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <label>Password</label>
                        <div className="input-wrapper">
                            <Lock size={18} className="input-icon" />
                            <input 
                                type={showPassword ? "text" : "password"} 
                                placeholder="Enter your password" 
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button 
                                type="button" 
                                className="eye-toggle" 
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="reg-btn" style={{ marginTop: '20px' }}>
                        Login Now <ArrowRight size={18} />
                    </button>
                </form>

                <div className="reg-footer">
                    <p>Don't have an account? <a href="/register">Create Account</a></p>
                </div>
            </div>
        </div>
    );
};

export default Login;